// extracted by mini-css-extract-plugin
module.exports = {"player-background__container":"player-background_player-background__container__xBwwC","player-background__image":"player-background_player-background__image__fSvec"};